import React from "react";
import "./AboutDifferent.scss";

import { AboutItemData } from "../../data/data";

const AboutDifferent = () => {
  return (
    <section className="section aboutDifferent">
      <article className="aboutDifferent__container container">
        <div className="aboutDifferent__container--header">
          <h1 className="aboutDifferent__title">
            What{" "}
            <span>
              Makes Us <br /> Different{" "}
            </span>{" "}
            from Others
          </h1>
        </div>

        <div className="aboutDifferent__container--contents">
          {AboutItemData.map((item, index) => (
            <div
              key={index}
              className="aboutDifferent__container--contents-items"
            >
              {item.icon}
              <h2 className="contents-items-title">{item.title}</h2>
              <p className="contents-items-text">{item.text}</p>
            </div>
          ))}
        </div>
      </article>

    </section>
  );
};

export default AboutDifferent;
